"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    goToLabel: 'Go to page number',
    currentLabel: '(current)',
    previousLabel: 'Go to previous page',
    previousText: 'Previous',
    nextLabel: 'Go to next page',
    nextText: 'Next'
  },
  fr: {
    goToLabel: 'Aller à la page n°',
    currentLabel: '(page actuelle)',
    previousLabel: 'Aller à la page précédente',
    previousText: 'Précédent',
    nextLabel: 'Aller à la page suivante',
    nextText: 'Suivant'
  }
};